import { render, staticRenderFns } from "./CustomIngredientModal.vue?vue&type=template&id=11e58cfd&scoped=true"
import script from "./CustomIngredientModal.vue?vue&type=script&lang=js"
export * from "./CustomIngredientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e58cfd",
  null
  
)

export default component.exports